import Alert from "../alert";
import { useState } from "react";

function AddUserModal({ showAdduser, handleClose }) {
    const [viewAlert, setViewAlert] = useState(false);

    return (
        <>


            {/* Alert */}
            <Alert
                show={viewAlert}
                message="User added successfully!"
                type="success"
                onClose={() => setViewAlert(false)}
            />
            <div
                className={`modal fade ${showAdduser ? "show d-block" : ""}`}
                tabIndex="-1"
                style={{ backgroundColor: showAdduser ? "rgba(0,0,0,0.5)" : "transparent" }}
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5 className="modal-title"><strong>Add User</strong></h5>

                            <button
                                type="button"
                                className="btn-close"
                                onClick={handleClose}
                            ></button>
                        </div>

                        <div className="modal-body">
                            <form className="row g-3">
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="First Name" required />
                                </div>
                                <div className="col-md-6">
                                    <input type="text" className="form-control" placeholder="Last Name" required />
                                </div>
                                <div className="col-12">
                                    <input type="text" className="form-control" placeholder="Username" required />
                                </div>
                                <div className="col-md-6">
                                    <input type="email" className="form-control" placeholder="Email" required />
                                </div>
                                <div className="col-md-6">
                                    <input type="password" className="form-control" placeholder="Password" required />
                                </div>
                                <div className="col-12">
                                    <input type="text" className="form-control" placeholder="Address" required />
                                </div>
                                <div className="col-md-6">
                                    <input type="File" className="form-control" placeholder="Choose Profile" required />
                                </div>
                                <div className="col-md-6">
                                    <select id="inputState" className="form-select" required>
                                        <option selected>Choose Role</option>
                                        <option>Master Admin</option>
                                        <option>Full Admin</option>
                                        <option>Temporary Admin</option>
                                    </select>
                                </div>
                            </form>
                            {/* <!-- End No Labels Form --> */}
                        </div>
                        <div className="modal-footer">

                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}
                            >
                                Close
                            </button>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    setViewAlert(true);
                                    handleClose();
                                }}
                            >
                                Save User
                            </button>

                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default AddUserModal;